import { Component, OnInit,Input} from '@angular/core';
import { Location } from '@angular/common';
import { FormGroup, Validators, FormBuilder, FormArray } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { LoadingState } from '../../loading/loading.component';
import {PerExecutionService} from '../../../services/per-execution.service';
import { SettingService} from '../../../services/setting.service';
import { forkJoin } from 'rxjs';
import * as moment from 'moment';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../../../core/components/confirm-dialog/confirm-dialog.component';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-office-safety-inner-tab',
  templateUrl: './office-safety-inner-tab.component.html',
  styleUrls: ['./office-safety-inner-tab.component.scss']
})
export class OfficeSafetyInnerTabComponent implements OnInit {

  @Input() projectId:number; 
  form: FormGroup;
  loading: LoadingState = LoadingState.NotReady;
  safetyAccessoryList :any = [];
  safetyDetail: any = [];
  safetyAccessoryDetail:any = [];
  safetyDocumentList:any = [];
  listEdit:boolean;
  survey_instrument:number=2;
  @Input() approveStatus:any = [];
  dialogRef: MatDialogRef<ConfirmDialogComponent>;

  constructor(
    private location: Location,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    public dialog: MatDialog,
    private perExecutionService:PerExecutionService,
    public settingService:SettingService
  ) { }

  ngOnInit() {
    this.form = this.formBuilder.group({
      project:[this.projectId],
      ppes_accessory:this.formBuilder.group({
        safety_accessory:[null,Validators.required],
        quantity:[null,Validators.required],
        total_cost:[null,Validators.required],
      }),
      requirment_s_date:[null,Validators.required],
      requirment_e_date:[null,Validators.required],
      budgeted_cost:[null,Validators.required],
      executed_cost:[null,Validators.required],
      documents:this.formBuilder.array([
        //this.createDocument()
      ])
    })
    if(this.projectId){
      this.getSafetyDetails();
      this.getAccessoryList();
    }
  }

  save(){
    if(this.form.valid){
      var saf_documents_data = [];
      saf_documents_data = this.form.value.documents;

      const data = {
          project: this.projectId,
          requirment_s_date:this.settingService.getProperDate(this.form.value.requirment_s_date).toISOString(),//aa
          requirment_e_date:this.settingService.getProperDate(this.form.value.requirment_e_date).toISOString(),//aa
          budgeted_cost:this.form.value.budgeted_cost,
          executed_cost:this.form.value.executed_cost,
          ppes_accessory:
          {
            project_id:this.projectId,
            safety_accessory:this.form.value.ppes_accessory.safety_accessory,
            quantity:this.form.value.ppes_accessory.quantity,
            total_cost:this.form.value.ppes_accessory.total_cost
          }
      }

      this.safetyDocumentList = [];
      this.perExecutionService.addSafetyOffice(data).subscribe(
        res => {
          console.log(res);
          var forkArray = [];

          saf_documents_data.forEach(x => {
              const formData: any = new FormData();
              formData.append("project",this.projectId);
              formData.append("module_id", res.ppes_accessory.id);
              formData.append("document_name", x.document_name);
              formData.append("document", x.safety_document, x.safety_document['name']);
              forkArray.push(this.perExecutionService.addSafetyAccessoryDocumentOffice(formData))
          })
          forkJoin(forkArray).subscribe(
            (result: any[]) => {
              // console.log(result)
              result.forEach(y => {
                this.safetyDocumentList.push(y)
              })
              
              // this.add_tender_document()
              this.loading = LoadingState.Ready;
            },
            err => {
              this.loading = LoadingState.Ready;
              // console.log(err)
            }
          )

          this.getAccessoryList(); 
          this.loading = LoadingState.Ready;
          this.toastr.success('Data has been saved','',{
            timeOut: 3000,
            });
          
        },
        error=>{
         // console.log(error);
          this.loading = LoadingState.Ready;
          this.toastr.error('Something went wrong', '', {
            timeOut: 3000,
            });
        })

      //console.log(data);

    }else
    {
      //console.log("error");
      this.markFormGroupTouched(this.form);
    
    }
  }

  getSafetyDetails(){
    this.perExecutionService.getSafetyOffice(this.projectId).subscribe(
      res => {
       if(res['result'][0]){
        this.safetyDetail = res['result'][0];
        //console.log(this.safetyDetail);

        var start_date = new Date(this.safetyDetail['requirment_s_date'])
            this.safetyDetail.requirment_s_date = {
              year: start_date.getFullYear(),
              month: start_date.getMonth()+1,
              day: start_date.getDate()
        
            }
            var end_date = new Date(this.safetyDetail['requirment_e_date'])
            this.safetyDetail.requirment_e_date = {
              year: end_date.getFullYear(),
              month: end_date.getMonth()+1,
              day: end_date.getDate()
              
            }
          
          this.safetyDetail.budgeted_cost = parseFloat(this.safetyDetail.budgeted_cost).toFixed(2);
          this.safetyDetail.executed_cost = parseFloat(this.safetyDetail.executed_cost).toFixed(2);
       }
       
        this.loading = LoadingState.Ready;
      },
      error =>{
        //console.log(error);
        this.loading = LoadingState.Ready;
        this.toastr.error('Something went wrong', '', {
          timeOut: 3000,
          });
      }
    )
  }

  getAccessoryList(){
    
    this.perExecutionService.getSafetyAccessoryListOffice(this.projectId).subscribe(
      res => {
        this.safetyAccessoryList = res['result'];
        
         //console.log(this.safetyAccessoryList);
        this.loading = LoadingState.Ready;
      },
      error => {
        //console.log(error);
        this.loading = LoadingState.Ready;
      }
    )
  }

  editAccessory(data){
    this.safetyAccessoryDetail = data;
   // console.log(this.safetyAccessoryDetail);
    this.safetyDocumentList = this.safetyAccessoryDetail.ppes_accessory_document_details;
    this.listEdit = true;
    // this.getAccessoryList(); 
  }

  deleteAccessory(id:number){

    this.dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: false
    });

    this.dialogRef.componentInstance.confirmMessage = "Are you sure you want to delete?"

    this.dialogRef.afterClosed().subscribe(result => {
     if(result){
      this.loading = LoadingState.Processing
      this.perExecutionService.deleteSafetyAccessoryListOffice(id).subscribe(
      res => {
       this.getAccessoryList();
         //console.log(res)
        this.loading = LoadingState.Ready
      },
      error => {
        // console.log(error)
        this.loading = LoadingState.Ready
      }
    )
	 }
	 this.dialogRef = null;
	 })
    
  }

    
  update(){
      if(this.form.valid){

        this.loading = LoadingState.Processing;
        var saf_documents_data = [];
        saf_documents_data = this.form.value.documents;

        const updateData = {
          project:this.projectId,
          requirment_s_date:this.settingService.getProperDate(this.form.value.requirment_s_date).toISOString(),//aa
          requirment_e_date:this.settingService.getProperDate(this.form.value.requirment_e_date).toISOString(),//aa
          budgeted_cost:this.form.value.budgeted_cost,
          executed_cost:this.form.value.executed_cost,
          ppes_accessory:
          {             
            project_id:this.projectId,
            safety_accessory:this.form.value.ppes_accessory.safety_accessory,
            quantity:this.form.value.ppes_accessory.quantity,
            total_cost:this.form.value.ppes_accessory.total_cost
          }
        }
      //console.log(updateData);

    this.perExecutionService.editSafetyOffice(this.safetyDetail.id,updateData).subscribe(
      res =>{
        // console.log(res);
        // console.log(res.tiffin_box_types.id)
       
        if(this.form.value.documents.length > 0){
          var forkArray = [];
          saf_documents_data.forEach(x => {
            const formData: any = new FormData();
            formData.append("project",this.projectId);
            formData.append("module_id", res.ppes_accessory.id);
            formData.append("document_name", x.document_name);
            formData.append("document", x.safety_document, x.safety_document['name']);
            forkArray.push(this.perExecutionService.addSafetyAccessoryDocumentOffice(formData))
          })
          forkJoin(forkArray).subscribe(
            result => {
              // console.log(result)
              result.forEach(y => {
                this.safetyDocumentList.push(y)
              })
             
              // this.add_tender_document();
              this.loading = LoadingState.Ready;
            },
            err => {
              this.loading = LoadingState.Ready;
              // console.log(err)
            }
          )
         }
        this.getAccessoryList();
        this.loading = LoadingState.Ready;
        this.toastr.success('Data has been saved','',{
          timeOut: 3000,
          });
      },
      error =>{
        this.loading = LoadingState.Ready;
        this.toastr.error('Something went wrong', '', {
          timeOut: 3000,
          });
      })
    }
    else{
      this.markFormGroupTouched(this.form);
      //console.log("error");
    }
  }

  updateAccessory()
  {
   
    var saf_documents_data = [];
    saf_documents_data = this.form.value.documents;

    if(this.form.valid){

      this.loading = LoadingState.Processing;
      const updateInstData = {
        project: this.projectId,
        safety_accessory: this.form.value.ppes_accessory.safety_accessory,
        quantity: this.form.value.ppes_accessory.quantity,
        total_cost: this.form.value.ppes_accessory.total_cost,
        ppes_details: {
          requirment_s_date:this.settingService.getProperDate(this.form.value.requirment_s_date).toISOString(),//aa
          requirment_e_date:this.settingService.getProperDate(this.form.value.requirment_e_date).toISOString(),//aa
          budgeted_cost:this.form.value.budgeted_cost,
          executed_cost:this.form.value.executed_cost,
        }
      }
      //console.log(updateInstData);

      //this.tiffinBoxDocumentList = [];
      this.perExecutionService.editSafetyAccessoryListOffice(this.safetyAccessoryDetail.id,updateInstData).subscribe(
        res =>{
          //console.log(res);
          var forkArray = [];

          if(this.form.value.documents.length > 0){
            saf_documents_data.forEach(x => {
              const formData: any = new FormData();
              formData.append("project",this.projectId);
              formData.append("module_id", this.safetyAccessoryDetail.id);
              formData.append("document_name", x.document_name);
              formData.append("document", x.safety_document, x.safety_document['name']);
              forkArray.push(this.perExecutionService.addSafetyAccessoryDocumentOffice(formData))
          })
          forkJoin(forkArray).subscribe(
            (result: any[]) => {
              // console.log(result)
              result.forEach(y => {
                this.safetyDocumentList.push(y)
              })
              
              // this.add_tender_document()
              this.loading = LoadingState.Ready;
            },
            err => {
              this.loading = LoadingState.Ready;
              // console.log(err)
            }
          )
      }
      this.getAccessoryList(); 
      this.loading = LoadingState.Ready;
      this.toastr.success('Data has been saved','',{
        timeOut: 3000,
        });
        },
        error =>{
          this.toastr.error('Something went wrong', '', {
            timeOut: 3000,
            });
        }
      )
      

    }else{
      //console.log("error");
    }
  }


  getFile(file: string) {
    var fileName = file.split('.')
    var fileExt = fileName[fileName.length - 1];
    if (fileExt == 'jpg' || fileExt == 'jpeg' || fileExt == 'png') {
      return file;
    }
    else {
      return 'assets/img/pdf.png'
    }
  }

  editDoc(index) {
    this.safetyDocumentList[index]['isEdit'] = true
    this.safetyDocumentList[index]['isFieldError'] = false
  }

  renameDoc(index) {
    if (this.safetyDocumentList[index]['document_name'] == '') {
      this.safetyDocumentList[index]['isFieldError'] = true;
    }
    else {
      this.loading = LoadingState.Processing
      this.safetyDocumentList[index]['isFieldError'] = false;
      var data = {
        document_name: this.safetyDocumentList[index]['document_name']
      }

      
      this.perExecutionService.editSafetyAccessoryDocumentOffice(this.safetyDocumentList[index]['id'], data).subscribe(
        res => {
          // console.log(res)
          this.safetyDocumentList[index]['isEdit'] = false
          this.loading = LoadingState.Ready

        },
        error => {
          // console.log(error)
          this.loading = LoadingState.Ready
        }
      )
    }
  }

  deleteDoc(index) {

    this.dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: false
    });

    this.dialogRef.componentInstance.confirmMessage = "Are you sure you want to delete?"

    this.dialogRef.afterClosed().subscribe(result => {
     if(result){
      this.loading = LoadingState.Processing
      this.perExecutionService.deleteSafetyAccessoryDocumentOffice(this.safetyDocumentList[index]['id']).subscribe(
      res => {
        this.safetyDocumentList.splice(index, 1)
        // console.log(res)
        this.loading = LoadingState.Ready
        this.getAccessoryList();
      },
      error => {
        // console.log(error)
        this.loading = LoadingState.Ready
      }
    )
	 }
	 this.dialogRef = null;
	 })
    
  }


  createDocument(){
    return this.formBuilder.group({
      document_name: ['', Validators.required],
      document: [null, Validators.required],
      safety_document: null
    })
  }

  getFormArrayControl(form) {
    return form.get('documents').controls
  }

  addDocument()
  {
    const control = <FormArray>this.form.controls['documents'];
    control.push(this.createDocument());
  }

  deleteDocument(index:number)
  {
    const control = <FormArray>this.form.controls['documents'];
    control.removeAt(index);

  }

  onSelectFile(event, index){
    //console.log(event.target.files);
    if (event.target.files && event.target.files[0]) {
      var filesAmount = event.target.files.length;
      for (let i = 0; i < filesAmount; i++) {
        var reader = new FileReader();
        reader.onload = (event) => {
          // console.log(event.target['result']);
        }
        const control = <FormArray>this.form.controls['documents'];
        control.at(index).patchValue({
          document: event.target.files[0]['name'],
          safety_document: event.target.files[0]
        })
        reader.readAsDataURL(event.target.files[i]);
      }
    }
  }

  markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      if (control.controls) { // control is a FormGroup
        this.markFormGroupTouched(control);
      } else { // control is a FormControl
        control.markAsTouched();
      }
    });
   }

  isFieldValid(form: FormGroup, field: string) {
    return !form.get(field).valid && (form.get(field).dirty || form.get(field).touched);
  }

  displayFieldCss(form: FormGroup, field: string) {
    return {
      'is-invalid': form.get(field).invalid && (form.get(field).dirty || form.get(field).touched),
      'is-valid': form.get(field).valid && (form.get(field).dirty || form.get(field).touched)
    };
  }

}
